import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

const TTML_CODE = `
<?xml version="1.0" encoding="UTF-8"?>
<!-- TTML Name -->
<tt
xmlns="http://www.w3.org/ns/ttml" xmlns:tts="http://www.w3.org/ns/ttml#styling"
xmlns:ttm="http://www.w3.org/ns/ttml#metadata"
xml:lang="en-US">
<head>
<metadata>
  <ttm:title>Song Name</ttm:title>
</metadata>
<ttm:agent xml:id="voice1" type="person">
  <ttm:name type="full">Artist Name</ttm:name>
</ttm:agent>
</head>
<body>
<div>
  <p begin="00:00:03.030" end="00:00:03.765">text text text</p>
  <p begin="00:00:04.525" end="00:00:05.260"> text text text  </p>
  <p begin="00:00:06.277" end="00:00:07.012"> text text text  </p>
</div>
</body>
</tt>
`;
export const HowAddLyrics: React.FC = () => {
  return <div id={"HowAddLyrics"}>
    <h2>
      Как добавить текст песни
    </h2>
    <p>
      Для добавления текста трека кликните на кнопку "Загрузить файл с текстами песен" и
      выберете заранее подготовленный по{" "}
      <a href={"/help/Шаблон_для_текстов.xlsx"} target={"_blank"}>Шаблону <FontAwesomeIcon
        className={"text-xs"} icon={faArrowUpRightFromSquare} /></a> xlsx-файл.
    </p>
    <div>
    </div>
    <div className={"text-center mb-3"}>
      <img className={"max-h-[350px]"} src={"/help/add_lyrics.jpg"} alt={"Добавить новый альбом"} />
    </div>
    <ul className={"list-disc"}>
      <li>ISRC — обязательное поле, по которому будет осуществлен маппинг текста</li>
      <li>Territory:Share% — территория указывается WW или СНГ, доля – 100</li>
      <li>Если вы передаете обычный (не караоке) формат текста, то поле Format оставьте пустым</li>
      <li>Загрузка караоке-текстов осуществляется также файлом в формате xlsx, но в поле Format должно быть обязательно
        указано ttml, а в поле для текста должен быть вставлен текст, соответствующий формату ttml.
      </li>
      <code>
          <pre className={"bg-gray-100 px-3 py-1 rounded my-2"}>
            {TTML_CODE}
          </pre>
      </code>
    </ul>

    <p className={"font-bold"}>Обратите внимание, для одного трека может быть только один формат текста: либо обычный
      текст, либо караоке-версия.</p>
  </div>;
};
